import {Injectable} from '@angular/core';
import {CanActivate, Routes} from '@angular/router';

import {Principal} from '../../shared';

import {AideComponent} from './aide.component';


@Injectable()
export class AideResolve implements CanActivate {

    constructor(private principal: Principal) {
    }

    canActivate() {
        return this.principal.identity().then(account => {
            return this.principal.hasAnyAuthority(['ROLE_SYSTEM', 'ROLE_ADMIN', 'ROLE_GEST']);
        });
    }
}


export const aideRoute: Routes = [
    {
        path: 'aide',
        component: AideComponent,
        data: {
            pageTitle: 'aide.home.title'
        }
    }
];





// WEBPACK FOOTER //
// ./src/main/webapp/app/admin/aide/aide.route.ts